import React from 'react';
import useTheme from 'branding/theme';
import getIconColor from '../../getIconColor';
const EditPenIcon = ({ type = 'utility', size = 'regular', disabled = false, styles, ...rest }) => {
    const { colors, sizing } = useTheme();
    const color = getIconColor(colors, type, disabled);
    const sizePx = sizing.widths.icon[size];
    return (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", width: sizePx, height: sizePx, style: styles, ...rest },
        React.createElement("g", { clipPath: "url(#clip0_1476_12297)" },
            React.createElement("path", { d: "M7.87122 18.6L4.19922 18.612V14.928L16.0312 3.09604C16.4392 2.68804 17.1112 2.68804 17.5192 3.09604L19.7032 5.28004C20.1112 5.68804 20.1112 6.36004 19.7032 6.76804L7.87122 18.6Z", stroke: color, strokeWidth: "2", strokeMiterlimit: "10", strokeLinejoin: "round" }),
            React.createElement("path", { d: "M2.69922 22.2002H21.2992", stroke: color, strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "round" }),
            React.createElement("path", { d: "M13.6191 5.42383L17.2911 9.09583", stroke: color, strokeWidth: "2", strokeMiterlimit: "10" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "clip0_1476_12297" },
                React.createElement("rect", { width: "24", height: "24", fill: "white" })))));
};
export default EditPenIcon;
//# sourceMappingURL=index.js.map